import { createFileRoute } from '@tanstack/react-router';

import { CrmCatalogsPage } from '@/features/owner/leads/CrmCatalogsPage';

export const Route = createFileRoute('/_authed/owner/crm-reasons')({
  component: CrmCatalogsPage,
});
